<template>
    <el-drawer :modal="false" 
        title="Edit Lead"
        :visible.sync="drawerEditLeadProfile"
        class="drawer-edit-lead-profile"
        size="45%"
    >
    <b-container>
        <b-form @submit.prevent="update">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Name:">
                        <b-form-input
                        v-model="form.name"
                        type="text"
                        size="md"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Contact Number:">
                        <div class="d-flex justify-content-start">
                            <b-form-input class="col-md-2 mr-1" v-model="form.country_code"></b-form-input>
                            <b-form-input
                            class="col-md-10"
                            v-model="form.contact_no"
                            type="text"
                            size="md"
                            required
                            ></b-form-input>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Email Address:">
                        <b-form-input
                        v-model="form.email"
                        type="email"
                        size="md"
                        :disabled="!_gHlp.isEmpty(lead.customer)"
                        ></b-form-input>
                        <b-form-text v-if="!_gHlp.isEmpty(lead.customer)" class="text-muted">
                            Your lead has been converted. Please edit your customer email in the customer profile.
                        </b-form-text>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Income:">
                        <b-form-input
                        v-model="form.income"
                        type="number"
                        size="md"
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAccess(['stg_channel_platform'])">
                    <b-form-group label="Platform">
                        <el-select v-model="form.platform_id" placeholder="Select">
                            <el-option
                            v-for="item in listPlatforms"
                            :key="item.platform_id"
                            :label="item.name"
                            :value="item.platform_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAccess(['stg_channel_platform'])">
                    <b-form-group label="Channel:" label-cols="12">
                        <el-select v-model="form.channel_id" placeholder="Select">
                            <el-option
                            v-for="item in listChanels"
                            :key="item.channel_id"
                            :label="item.name"
                            :value="item.channel_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="checkAccess(['stg_channel_platform'])">
                    <b-form-group label="Type:">
                        <el-select v-model="form.type" placeholder="Select Type">
                            <el-option label="Personal" value="Personal"/>
                            <el-option label="Company" value="Company"/>
                        </el-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col>
                        <b-form-group cols="12" md="6">
                            <el-date-picker v-model="form.appointment_at" type="datetime" format="yyyy-MM-dd hh:mm:ss"
                                value-format="yyyy-MM-dd hh:mm:ss" placeholder="Select appointment time and date">
                            </el-date-picker>
                        </b-form-group>
                    </b-col> -->
                 <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary" :disabled="is_loading">Edit</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
    </el-drawer>
</template>
<script>
    import { Button, Drawer, DatePicker, Collapse, CollapseItem, Select, Option } from 'element-ui'
    import {
        notifyFunctionMixin,
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'
    import { mapActions } from 'pinia'
    import { useLeadStore } from '@/stores/leadStore'
		import _ from 'lodash'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'

    export default {
        props: ['lead'],
        components: {
            [Button.name]: Button,
            [Drawer.name]: Drawer,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,
        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        computed: {
            listChanels(){
                let dataList = this.tables.channels;
                let corporate_id = _gAuth.activeCorporateId();
                return _.filter(dataList, function(o) { return (o.corporate_id == corporate_id) && (!o.deleted_at); });
            },
            listPlatforms(){
                let dataList = this.tables.platforms;
                let corporate_id = _gAuth.activeCorporateId();
                return _.filter(dataList, function(o) { return (o.corporate_id == corporate_id) && (!o.deleted_at); });
            }
        },
        data() {
            return {
                drawerEditLeadProfile: false,
                form: {
                    name: '',
                    country_code: '+60',
                    contact_no: '',
                    email: '',
                    income: '',
                    channel_id: '',
                    platform_id: '',
                    type: '',
                    // appointment_at: '',
                },
                tables:[],
                is_loading: false,
            };
        },
        watch: {
            lead: {
                immediate: true, 
                handler(newVal) {
                    this.setFormValues(newVal);
                }
            },
            async drawerEditLeadProfile(newVal){
                if(newVal === true && this.tables.length === 0){
                    this.tables = await this.getLookupTables(['platforms',' channels'])
                }
            }
        },
        mounted() {
            this.getLookupTables(['platforms',' channels'])
        },
        methods: {
            setFormValues(lead) {
                this.form.name = lead.name ?? '';
                this.form.contact_no = lead.contact_no ?? '';
                this.form.email =  !_gHlp.isEmpty(lead.customer) ? (lead.customer.email ?? "") :  lead.email ?? '';
                this.form.income = lead.income ?? '';
                this.form.channel_id = lead.channel_id ?? '';
                this.form.platform_id = lead.platform_id ?? '';
                this.form.type = lead.type ? lead.type.charAt(0).toUpperCase() + lead.type.slice(1) : 'Personal';
                // this.form.appointment_at = lead.appointment_at ?? '';

            },
            ...mapActions(useLeadStore,['getLead']),
            update(){
                this.is_loading = true
                axios.put(services.lead + 'leads/'+ this.$route.params.lead_id, this.form, { headers: getHeader()})
                    .then(res => { 
                        this.is_loading = false
                        this.notifySuccess('<b>Lead : ' + res.data.data.name + '</b> - Successfully Updated.')
                        this.getLead(this.$route.params.lead_id)
                    })
                    .catch(e => {
                        this.is_loading = false
                        this.errorFunction(e)
                    })
            },
            viewEditProfile() {
                this.drawerEditLeadProfile = !this.drawerEditLeadProfile;
            }
        }
    }
</script>